<template>
  <perfect-scrollbar
    ref="scroll"
    :options="{ suppressScrollX: true, minScrollbarLength: 10 }"
  >
    <draggable
      :animation="200"
      dragClass="is-drag"
      :forceFallback="true"
      ghostClass="is-ghost"
      group="task"
      handle="li"
      :list="items"
      tag="ul"
      class="c-list--task is-sortable-dropping"
      :fallbackTolerance="1"
      @start="start"
      @end="end"
      @add="update"
      @update="update"
      @change="change"
    >
      <slot></slot>
    </draggable>
  </perfect-scrollbar>
</template>
<script>
import draggable from 'vuedraggable';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import apiProjects from '@/api/projects';
export default {
  props: {
    column: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    draggable,
    PerfectScrollbar
  },
  methods: {
    start() {
      document.documentElement.classList.add('is-sortable-dragging');
    },
    end() {
      document.documentElement.classList.remove('is-sortable-dragging');
    },
    change(e) {
      if (e.added) {
        // itemのcolumnの情報が古いので更新する必要がある
        this.$emit('sort', e.added.element.id, this.column);
      }
    },
    update(e) {
      const item = this.items[e.newIndex];
      const params = {
        column: item.column,
        position: e.newIndex,
        taskDetail: null,
        type: item.type,
        updatedAt: item.updatedAt
      };
      apiProjects.tasks
        .put(params, this.auth.idToken, this.project.id, item.id)
        .then(response => {
          // 移動したタスクの更新時間を更新する
          item.updatedAt = response.data.updatedAt;
          this.$emit('edit', item);
        });
    }
  }
};
</script>
